import { useI18n } from "../i18n";
import { SectionHeading } from "./ui/card";
import { Accordion } from "./ui/accordion";
import { Reveal } from "./reveal";

/** FAQ — perguntas que sempre aparecem, uma aberta por vez. */
export function Faq() {
  const { t } = useI18n();
  const perguntas = [1, 2, 3, 4, 5, 6].map((n) => ({
    question: t(`faq.q${n}.q`),
    answer: t(`faq.q${n}.a`),
    defaultOpen: n === 1,
  }));

  return (
    <section id="faq" className="relative scroll-mt-24 bg-surface-2/50 py-24 sm:py-32">
      <div className="mx-auto max-w-6xl px-6">
        <div className="grid gap-10 lg:grid-cols-[1fr_1.6fr] lg:gap-16">
          <Reveal>
            <SectionHeading
              index="07"
              label={t("faq.rotulo")}
              title={t("faq.titulo")}
              align="left"
              className="lg:sticky lg:top-28"
            />
          </Reveal>
          <Reveal delay={0.1}>
            <Accordion items={perguntas} />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
